<template>
  <div id="app">
    <v-app>
      <v-navigation-drawer></v-navigation-drawer>
      <v-toolbar>
        <v-toolbar-title>Harmap</v-toolbar-title>
      </v-toolbar>
      <main>
        <v-container fluid>
          <v-layout>
            <v-flex xs10 hidden-md-and-up>
              <v-select v-if="localTuning" :items="catalogue" item-text="name" v-model="localTuning"></v-select>
            </v-flex>
            <v-flex xs2 hidden-md-and-up>
              <v-select v-if="localKey" :items="possibleKeys" item-text="short" item-value="pitch" v-model="localKey"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md2 hidden-sm-and-down>
              <v-list dense>
                <v-list-item v-for="tuning in catalogue" :key="tuning" @click.stop="localTuning = tuning">
                  <v-list-tile avatar>
                    <v-list-tile-action>
                      <v-icon v-if="localTuning === tuning" class="pink--text">star</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="tuning.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-item>
              </v-list>
            </v-flex>
            <v-flex md2 hidden-sm-and-down>
              <v-list dense class="localKey">
                <v-list-item v-for="k in possibleKeys" :key="k.pitch" @click.stop="localKey = k.pitch">
                  <v-list-tile avatar>
                    <v-list-tile-action>
                      <v-icon v-if="localKey === k.pitch" class="pink--text">star</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="k.short"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-item>
              </v-list>
            </v-flex>
            <v-flex md10 xs12>
              <harmap-grid :pattern="localTuning" :harp-key="selectedKey"></harmap-grid>
              <div v-html="comment"></div>
            </v-flex>
          </v-layout>
        </v-container>
      </main>
      <v-footer></v-footer>
    </v-app>
  </div>
</template>

<script>
import HarmapGrid from './components/HarmapGrid'
import { SCALE, getShortName } from './solfege'
import { mapState, mapActions } from 'vuex'
import marked from 'marked'

export default {
  name: 'app',

  components: { HarmapGrid },

  computed: {
    localTuning: {
      get () { return this.currentHarmonica },
      set (value) { this.changeTuning(value) }
    },
    localKey: {
      get () { return this.selectedKey },
      set (value) { this.changeSelectedKey(value) }
    },
    possibleKeys () {
      return SCALE.filter(x => x.pitch > 20) // E2
                  .filter(x => x.pitch < 49) // A4
    },
    comment () {
      return marked(this.localTuning.comment)
    },

    ...mapState([
      'catalogue',
      'currentHarmonica',
      'selectedKey'
    ])
  },

  methods: {
    getShortName,

    ...mapActions([
      'changeSelectedKey',
      'changeTuning'
    ])
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?d13519ae